import api from './api';

class NotificationService {
  async getNotifications({ page = 1, limit = 20, unreadOnly = false } = {}) {
    const params = new URLSearchParams({ page, limit });
    if (unreadOnly) params.append('unreadOnly', 'true');

    const response = await api.get(`/notification?${params}`);
    if (response.success && response.data) {
      return response.data;
    }
    return { notifications: [], unreadCount: 0, pagination: { page: 1, totalPages: 1, total: 0 } };
  }

  async getUnreadCount() {
    const response = await api.get('/notification/unread-count');
    if (response.success && response.data) {
      return response.data.count || 0;
    }
    return 0;
  }

  async markAsRead(notificationId) {
    const response = await api.patch(`/notification/${notificationId}/read`);
    return response.success;
  }

  async markAllAsRead() {
    const response = await api.patch('/notification/read-all');
    return response.success;
  }
}

const notificationService = new NotificationService();
export default notificationService;
